import { Grid } from '@mui/material';
import { useTheme } from '@mui/styles';
import { ToolbarButton } from '@tassat/button';
import { AdminRoleId } from '@tassat/common-definitions';
import React from 'react';

import authService from 'Lib/auth/AuthService';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';
import { useAppSelector } from 'Reducers/store/hooks';
import { getCurrentRole, getUser } from 'Selectors/common';
import ClientUserSearch from 'SharedComponents/users/ClientUserSearch';

import type { HeaderProps } from '.';

export default function Header(props: HeaderProps) {
    const { classes } = props;

    const userRole = useAppSelector(getCurrentRole);
    const user = useAppSelector(getUser);
    const theme = useTheme<ApplicationMuiTheme>();

    if (!user) {
        return null;
    }

    if (user?.IsAdmin && theme?.app?.clientTheme.layoutSettings.useGlobalHeader) {
        return null;
    }

    if (!user?.IsAdmin && theme?.app?.clientTheme.layoutSettings.useClientGlobalHeader) {
        return null;
    }

    return (
        <Grid
            alignItems='center'
            className={classes.container}
            container
            direction='row'
            justifyContent='flex-end'
            spacing={0}
            wrap='nowrap'
        >
            {user?.IsAdmin &&
                [ AdminRoleId.BANK_OPS as string, AdminRoleId.BANK_OPS_SUPERVISOR as string, AdminRoleId.CLIENT_SERVICES as string ].includes(userRole?.AdminRoleId || '') &&
                <ClientUserSearch />}
            <ToolbarButton
                className={classes.logout}
                onClick={authService.logout}
                text='LOG OUT'
            />
        </Grid>
    );
}